// Zentrale de-DE-Zahlformatierung für UI-Anzeigen.
//
// Konventionen (Text-Audit B5):
//  - Dezimal-Komma, Punkt als Tausendertrenner (de-DE)
//  - geschütztes Leerzeichen (NBSP) zwischen Zahl und Einheit,
//    damit „89 €" nie am Zeilenende auseinanderbricht
//
// NICHT für <input type="number">-Values verwenden — die brauchen den
// Punkt als Dezimaltrennzeichen (toFixed bleibt dort korrekt).

/** Geschütztes Leerzeichen (U+00A0) — zwischen Zahl und Einheit (€, %, h …). */
export const NBSP = ' '

/** de-DE-Dezimalzahl, Default 2 Nachkommastellen (z.B. 1234.5 → "1.234,50"). */
export function formatNumber(value: number, decimals = 2): string {
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

/** Cents als Betrag mit NBSP vor der Währung (8900 → "89,00 €").
 *  EUR wird als €-Symbol gerendert, andere Währungen als ISO-Code. */
export function formatCurrency(cents: number, currency = 'EUR'): string {
  const unit = currency === 'EUR' ? '€' : currency
  return `${formatNumber(cents / 100)}${NBSP}${unit}`
}
